import { BaseComponent, SbBlokData } from '@cinch-nx/data-storyblok'
import { StoryblokRenderer } from '@cinch-nx/storyblok-utils'
import { atomStoryblokComponents } from '../../data-maps/atom-storyblok-components-map'
import { Text } from '@cinch-labs/design-system'
import styles from './offer-card.module.css'

interface OfferCardProps extends BaseComponent {
  component: 'OfferCard'
  image: SbBlokData[]
  disclaimer: string
  title: string
  financeInformations: SbBlokData[]
  extraInfo: string
}

export const OfferCard = ({
  image,
  disclaimer,
  title,
  financeInformations,
  extraInfo,
}: OfferCardProps) => (
  <div>
    <StoryblokRenderer block={image} components={atomStoryblokComponents} />
    <Text>{disclaimer}</Text>
    <div className={styles.infoSection}>
      <Text className={styles.title}>{title}</Text>
      <div>
        {financeInformations.map((info) => (
          <StoryblokRenderer
            block={info}
            components={atomStoryblokComponents}
          />
        ))}
      </div>
      <Text className={styles.extraInfo}>{extraInfo}</Text>
    </div>
  </div>
)
